import { FC } from 'react';

import { DeskBookingFilterButton } from '../../DeskBookingFilters/DeskBookingFilterButton';
import { DeskBookingSettings } from '../../DeskBookingSettings/DeskBookingSettings';
import { DeskOfficeSidesheetButton } from '../../DeskOffice/DeskOfficeSidesheetButton';
import { DeskSearch } from '../../DeskSearch/DeskSearch';

import classes from './MobilePageActions.module.scss';

export const MobilePageActions: FC = () => {
  return (
    <div className={classes.container}>
      <div className={classes.office}>
        <DeskOfficeSidesheetButton />
      </div>
      <DeskBookingSettings />
      <div className={classes.controls}>
        <div className={classes.search}>
          <DeskSearch />
        </div>
        <DeskBookingFilterButton />
      </div>
    </div>
  );
};
